import { create } from 'zustand';
import { IUser } from '../interfaces/IUser';

export interface UserStoreState {
  users: IUser[];
  loading: boolean;
  error: string | null;
  selectedUser: IUser | null;
  setUsers: (users: IUser[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  setSelectedUser: (user: IUser | null) => void;
  addUser: (user: IUser) => void;
  updateUser: (user: IUser) => void;
  removeUser: (userId: string) => void;
  clearError: () => void;
}

export const useUserStore = create<UserStoreState>((set) => ({
  users: [],
  loading: false,
  error: null,
  selectedUser: null,

  setUsers: (users) => set({ users }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  setSelectedUser: (user) => set({ selectedUser: user }),
  
  addUser: (user) =>
    set((state) => ({
      users: [...state.users, user],
    })),

  updateUser: (user) =>
    set((state) => ({
      users: state.users.map((u) => (u.id === user.id ? user : u)),
    })),

  removeUser: (userId) =>
    set((state) => ({
      users: state.users.filter((u) => u.id !== userId),
    })),

  clearError: () => set({ error: null }),
}));
